import { toCtaData } from "@/contents/converters/atoms"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { SanityDecoration } from "@/contents/molecules/SanityDecoration"
import { InfoBlock as InfoBlockContent } from "@/contents/sanityTypes"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import InfoBlock from "@/ui/organisms/InfoBlock"

export interface SanityInfoBlockProps {
  content: InfoBlockContent
}

const SanityInfoBlock = ({ content }: SanityInfoBlockProps) => {
  return (
    <BlokWrapper contents={content} menuColor="light">
      <InfoBlock
        title={<SanityRichTextField value={content.title} />}
        message={<SanityRichTextField value={content.message} />}
        cta={toCtaData(content.cta)}
        decorations={[
          ...(content.decoration1?.image?.asset
            ? [
                <SanityDecoration
                  key={1}
                  asset={content.decoration1.image.asset}
                  position={content.decoration1.position ?? {}}
                  size={content.decoration1.size ?? {}}
                  absolute
                />,
              ]
            : []),
          ...(content.decoration2?.image?.asset
            ? [
                <SanityDecoration
                  key={2}
                  asset={content.decoration2.image.asset}
                  position={content.decoration2.position ?? {}}
                  size={content.decoration2.size ?? {}}
                  absolute
                />,
              ]
            : []),
          ...(content.decoration3?.image?.asset
            ? [
                <SanityDecoration
                  key={3}
                  asset={content.decoration3.image.asset}
                  position={content.decoration3.position ?? {}}
                  size={content.decoration3.size ?? {}}
                  absolute
                />,
              ]
            : []),
        ]}
      />
    </BlokWrapper>
  )
}

export default SanityInfoBlock
